export default (that = {}) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'checkbox',
    width: 60,
    align: 'center',
    fixed: 'left',
    type: 'checkbox',
  },
  {
    title: that.$l('INDEX.table_label_number_of_cabinets') || '入柜箱数',
    field: 'containerBoxQty',
    width: 120,
    fixed: 'left',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    editRender: {
      name: 'ElInputNumber',
      props: {
        controlsPosition: 'right',
        style: 'width:100%',
        min: 1,
        step: 1,
        precision: 0,
      },
      placeholder: '请输入数量',
      immediate: true,
    },
  },
  {
    title: that.$l('form_label_containerBoxQtyWait') || '待入柜箱数',
    field: 'notInBoxQty',
    width: 100,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.form_label_cargoReadyDay') || '货好时间',
    field: 'deliveryDate',
    width: 120,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    slots: {
      header: 'deliveryDateHeader',
    },
  },
  {
    title: that.$l('INDEX.order_form_batch_label_shipmentDate') || '客户交期',
    field: 'shipmentDate',
    headerAlign: 'center',
    align: 'center',
    width: 120,
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    slots: {
      header: 'shipmentDateHeader',
    },
  },
  {
    title: that.$l('INDEX.table_label_destinationPort') || '目的港口',
    field: 'v_destinationPort',
    minWidth: 120,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    slots: {
      header: 'destinationPortHeader',
    },
  },
  {
    title: that.$l('INDEX.table_label_deliveryType') || '出货方式',
    field: 'v_deliveryType',
    minWidth: 120,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    slots: {
      header: 'deliveryTypeHeader',
    },
  },
  {
    title: that.$l('INDEX.table_label_contractNo') || '合同号',
    field: 'contractNo',
    minWidth: 150,
    align: 'center',
    showOverflow: true,
    sortable: true,
    slots: {
      header: 'contractNoHeader',
    },
  },
  {
    title: that.$l('INDEX.table_label_retailerPo') || '零售商PO',
    field: 'retailerPo',
    minWidth: 150,
    align: 'center',
    showOverflow: true,
    sortable: true,
    slots: {
      header: 'retailerPoHeader',
    },
  },
  {
    title: that.$l('INDEX.table_label_importerPo') || '进口商PO',
    field: 'importerPo',
    minWidth: 150,
    align: 'center',
    showOverflow: true,
    sortable: true,
    slots: {
      header: 'importerPoHeader',
    },
  },

  {
    title: that.$l('INDEX.table_label_orderGoodsItemNo') || 'Item No',
    field: 'orderGoodsItemNo',
    minWidth: 150,
    align: 'center',
    showOverflow: true,
    sortable: true,
    slots: {
      header: 'orderGoodsItemNoHeader',
    },
  },

  {
    title: that.$l('INDEX.order_goods_label_identifyGoodsNo') || '产品识别编号',
    field: 'identifyGoodsNo',
    align: 'center',
    headerAlign: 'center',
    width: 200,
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    slots: {
      header: 'identifyGoodsNoHeader',
    },
  },
  {
    title: that.$l('INDEX.table_label_execution_plant') || '执行工厂',
    field: 'executeScmName',
    align: 'center',
    headerAlign: 'center',
    width: 140,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
    slots: {
      header: 'executeScmHeader',
    },
  },
  {
    title: that.$l('INDEX.table_label_settlementFactoryName') || '结算工厂',
    field: 'settlementFactoryName',
    align: 'center',
    headerAlign: 'center',
    width: 140,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
    slots: {
      header: 'settlementFactoryHeader',
    },
  },
  {
    title: that.$l('INDEX.table_label_orderExecuteType') || '业务性质',
    field: 'v_orderExecuteType',
    align: 'center',
    headerAlign: 'center',
    width: 120,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
    slots: {
      header: 'orderExecuteTypeHeader',
    },
  },
  {
    title: that.$l('INDEX.table_label_boxLength') || '箱长（cm）',
    field: 'boxLength',
    width: 100,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
  },
  {
    title: that.$l('INDEX.table_label_boxWidth') || '箱宽（cm）',
    field: 'boxWidth',
    width: 100,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
  },
  {
    title: that.$l('INDEX.table_label_boxHeight') || '箱高（cm）',
    field: 'boxHeight',
    width: 100,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
  },
  {
    title: that.$l('INDEX.table_label_boxVolume') || '箱体积（立方米）',
    field: 'boxVolume',
    width: 150,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_totalBoxVolume') || '总箱体积（立方米）',
    field: 'totalBoxVolume',
    width: 150,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.order_package_packingType') || '装箱方式',
    field: 'v_packingType',
    align: 'center',
    headerAlign: 'center',
    width: 110,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    title: that.$l('INDEX.table_label_goodsNameDisplay') || '产品中文说明',
    field: 'goodsNameDisplay',
    align: 'center',
    headerAlign: 'center',
    minWidth: 170,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_goods_spec_display') || '规格尺寸说明',
    field: 'goodsSpecDisplay',
    align: 'center',
    headerAlign: 'center',
    minWidth: 150,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_dispatchPort') || '发运港口',
    field: 'v_dispatchPort',
    width: 120,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    slots: {
      header: 'dispatchPortHeader',
    },
  },
  {
    title: that.$l('INDEX.table_batchGoodsQty') || '批次产品总数量',
    field: 'batchGoodsQty',
    width: 150,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
  },
  {
    title: that.$l('INDEX.table_label_box_net_weight') || '单箱净重（kg）',
    field: 'boxNetWeight',
    align: 'center',
    headerAlign: 'center',
    width: 100,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    title: that.$l('INDEX.table_label_box_gross_weight') || '单箱毛重（kg）',
    field: 'boxGrossWeight',
    align: 'center',
    headerAlign: 'center',
    width: 100,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    title: that.$l('INDEX.table_label_box_price_amount') || '单箱成本总价',
    field: 'boxPriceAmount',
    align: 'center',
    headerAlign: 'center',
    width: 120,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    slots: {
      default: 'boxPriceAmount',
    },
  },
  {
    title: that.$l('INDEX.table_label_box_sale_price_amount') || '单箱销售总价',
    field: 'boxSalePriceAmount',
    align: 'center',
    headerAlign: 'center',
    width: 120,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    slots: {
      default: 'boxSalePriceAmount',
    },
  },
]
